/**
 * Paiement Stripe en cours, garde le temps d'un aller-retour chez Stripe.
 *
 * Le retour normal passe par l'adresse (bz_booking, ou #bz-booking= sur la
 * page du studio). Mais un site hote peut la nettoyer, et un ancien embed.js
 * en cache ne lit pas l'ancre : au chargement suivant, le widget retrouve ici
 * le paiement et montre sa confirmation. Sert aussi a envoyer checkout_paid
 * une seule fois, au retour.
 */
export type PendingCheckout = {
  bookingId: string;
  classSessionId: string;
  method: string | null;
  passType: string | null;
  at: number;
};

const KEY = "bz_pending_checkout";
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export function rememberPendingCheckout(pending: Omit<PendingCheckout, "at">) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...pending, at: Date.now() }));
  } catch {
    // Stockage bloque : le retour par l'adresse reste possible.
  }
}

/** Le paiement en cours, s'il date de moins de deux heures. */
export function readPendingCheckout(): PendingCheckout | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const pending = JSON.parse(raw) as PendingCheckout;
    if (Date.now() - pending.at > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return pending;
  } catch {
    return null;
  }
}

export function forgetPendingCheckout() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // rien a nettoyer
  }
}
